import Source from '../../models/source';
import Track from '../../models/track';
import MixcloudTrack from '../../models/track/mixcloudTrack';

/**
 * The mixcloud.com page for a library track, when it is a Mixcloud one.
 *
 * Tracks come out of the library as plain JSON, so this reads the property
 * MixcloudTrack stored rather than testing the class - the same as
 * soundCloudPermalink. A show whose record predates that property can still
 * be rebuilt from its key, which is the path of its page.
 */
export function mixcloudUrl(track: Track | undefined): string | undefined {
  if (!track || track.type !== Source.Mixcloud) {
    return undefined;
  }

  const url = (track as MixcloudTrack).url;

  if (typeof url === 'string' && url) {
    return url;
  }

  return track.id ? `https://www.mixcloud.com${track.id}` : undefined;
}

/** A new tab, with no opener: the Mixcloud page has no business with this window. */
export function openOnMixcloud(url: string) {
  window.open(url, '_blank', 'noopener,noreferrer');
}
